module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEZSURBVEhL7dQxSkNBEMbxZxRS5wCaswhW2qWLxxA8gwQUvIOI5AqG2JvOG4i2okVIkSLq/4O3MAyz+zap88GPZXZ33gsJk2afXXOCGZbtqjpKHw/tulX00D/jGVHuoHOtW2UN+wLVPqfYQOdaVXfmCBPYhyfaP4QywAfsuWrtF3ML2+TdQHlEdK79Yr4QNSbvSLmHPVPdma4XXEE5wy/smWrtFzOFbbLmOIC+5892z9N+9ncYwX+q5BvHUJ4Q3Ul0HuYNUYOMYaPB8vdVFwduBdsQuYaSBswrDtwCUVPygh7sgHnFgTtH1CQ/GCIaMK84cBd4hf+ruISSGzCvc+AU25BLzZ1sappr7mRT01xzJ5ua5po7+5TSNP+VY8cvTjvjEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-forest/dark/24.png
// module id = 2078
// module chunks = 2